import { IXmlNode } from '@/app-modules/server-communications';
import { DefaultStageElement } from '@/components/game/implementations/_default/_domain/models';
import { PrizeWinnerData } from '@/components/game/_domain/server/prize-winner/prize-winner-data';

class DefaultPrizeWinnerData extends PrizeWinnerData {
  protected getStages(node: IXmlNode): DefaultStageElement[] {
    return [{ name: 'prize', stage: 1 }];
  }
}

export { DefaultPrizeWinnerData };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/game/implementations/_default/_domain/models/prize-winner.ts